module.exports = __webpack_public_path__ + "static/media/Desktop_Inscribirse.b1b2aa09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewcc/Desktop_Inscribirse.png
// module id = 98
// module chunks = 0